import api from "src/api/axiosInstance";
import { setcategory } from "src/store/slices/category-slice";
import { store } from "src/store/store";

export const fetchCategories = async () => {
  try {
    const response = await api.get(`/categories?page=1&limit=100`);
    if (response.data.status === 0) {
      store.dispatch(setcategory(response.data.data));
      return response.data.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const fetchCategoryProduct = async (category) => {
  try {
    const response = await api.post(
      `/products-filter?page=1&status=1&limit=1000`,
      { categories: [`${category}`] } // Sending category in the request body
    );
    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error filtering products:", error);
    return null;
  }
};

export const fetchProductByCategoryAndSortOption = async (
  category,
  sortOption,
  minPrice,
  maxPrice,
  inStock,
  outOfStock,
  categories
) => {
  try {

    let payload = {
      categories: [`${category}`]
    };
    
    // Add sorting option
    if (sortOption && sortOption !== "default") {
      payload.sortbyprice = `${sortOption}`;
    }
    
    // Add price range if provided
    if (minPrice) {
      payload.minPrice = parseInt(minPrice);
    }
    
    if (maxPrice) {
      payload.maxPrice = parseInt(maxPrice);
    }
    
    // Add stock status if selected
    if (inStock) {
      payload.instock = true;
    } else if (outOfStock) {
      payload.instock = false;
    }

    if (categories && categories.length > 0) {
      payload["categories"] = categories;
    }
    
     const response = await api.post(
      `/products-filter?page=1&status=1&limit=1000`,
        payload
    );
    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error filtering products:", error);
    return null;
  }
};

export const fetchShopAllProductsBySortOptions = async (payload) => {
  try {
    const response = await api.post(
      `/products-filter?page=1&limit=1000`,
      payload
    );
    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error filtering products:", error);
    return [];
  }
};

export const fetchFilteredProducts = async (payload) => {
  try {
    const response = await api.post('/products-filter?page=1&limit=1000', {
      payload
    });
    return await response.json();
  } catch (error) {
    console.error("Failed to fetch filtered products:", error);
    return [];
  }
};
